import { render, staticRenderFns } from "./OpExchangeFooter.vue?vue&type=template&id=a1d4e7aa&"
import script from "./OpExchangeFooter.vue?vue&type=script&lang=ts&"
export * from "./OpExchangeFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports